// extracted by mini-css-extract-plugin
export default {"root":"ResetPassword_root__nrij0","root_form":"ResetPassword_root_form__lPb-8","root_logo":"ResetPassword_root_logo__N1bYK","root_border":"ResetPassword_root_border__CYyJW"};